import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Loader2 } from 'lucide-react'
import { API_ROUTES, apiFetch } from '@/config/api-routes'

export default function AdminNovoMedicoPage() {
  const [nome, setNome] = useState('')
  const [email, setEmail] = useState('')
  const [senha, setSenha] = useState('')
  const [crm, setCrm] = useState('')
  const [especialidades, setEspecialidades] = useState('')
  const [nomeWorkspace, setNomeWorkspace] = useState('')
  const [busy, setBusy] = useState(false)
  const [erro, setErro] = useState<string | null>(null)
  const [sucesso, setSucesso] = useState<{ workspaceId: string; email: string } | null>(null)

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    setErro(null)
    setSucesso(null)
    if (nome.trim().length < 3 || nomeWorkspace.trim().length < 3) {
      setErro('Nome e workspace são obrigatórios (mín. 3 caracteres).')
      return
    }
    if (senha.length < 8) {
      setErro('Senha inicial deve ter pelo menos 8 caracteres.')
      return
    }
    setBusy(true)
    try {
      const r = await apiFetch(API_ROUTES.admin.medicos, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          nome: nome.trim(),
          email: email.trim(),
          senha,
          nomeWorkspace: nomeWorkspace.trim(),
          crm: crm.trim() || null,
          especialidades: especialidades.split(',').map(s => s.trim()).filter(Boolean),
        }),
      })
      const j = await r.json()
      if (!r.ok) throw new Error(j.error ?? 'Falha ao provisionar')
      setSucesso({ workspaceId: j.workspaceId, email: j.email })
      setNome('')
      setEmail('')
      setSenha('')
      setCrm('')
      setEspecialidades('')
      setNomeWorkspace('')
    } catch (err) {
      setErro(err instanceof Error ? err.message : 'Erro ao provisionar médico')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div>
      <header style={{ marginBottom: 20 }}>
        <h1 className="page-title">Provisionar médico</h1>
        <p className="page-subtitle" style={{ margin: 0 }}>
          Cria conta Auth, perfil e workspace titular em uma operação.
        </p>
      </header>

      {sucesso && (
        <div className="card badge-ok" style={{ padding: 14, marginBottom: 16, background: 'var(--ok-soft)' }} role="status">
          Médico <strong>{sucesso.email}</strong> provisionado.
          {' '}
          <Link to={`/admin/workspaces/${sucesso.workspaceId}`} style={{ fontWeight: 700 }}>
            Ver workspace
          </Link>
        </div>
      )}

      <form onSubmit={submit} className="card" style={{ padding: 20, display: 'flex', flexDirection: 'column', gap: 14, maxWidth: 520 }}>
        <div>
          <label className="field-label" htmlFor="adm-nome">Nome completo *</label>
          <input id="adm-nome" className="field-input" required value={nome} onChange={e => setNome(e.target.value)} />
        </div>
        <div>
          <label className="field-label" htmlFor="adm-email">E-mail *</label>
          <input id="adm-email" type="email" className="field-input" required value={email} onChange={e => setEmail(e.target.value)} />
        </div>
        <div>
          <label className="field-label" htmlFor="adm-senha">Senha inicial *</label>
          <input id="adm-senha" type="password" className="field-input" required minLength={8} value={senha} onChange={e => setSenha(e.target.value)} />
        </div>
        <div>
          <label className="field-label" htmlFor="adm-ws">Nome do workspace *</label>
          <input id="adm-ws" className="field-input" required value={nomeWorkspace} onChange={e => setNomeWorkspace(e.target.value)} placeholder="Ex.: Consultório Dra. Maria" />
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
          <div>
            <label className="field-label" htmlFor="adm-crm">CRM</label>
            <input id="adm-crm" className="field-input" value={crm} onChange={e => setCrm(e.target.value)} placeholder="00000/UF" />
          </div>
          <div>
            <label className="field-label" htmlFor="adm-esp">Especialidades</label>
            <input id="adm-esp" className="field-input" value={especialidades} onChange={e => setEspecialidades(e.target.value)} placeholder="Ginecologia, Mastologia" />
          </div>
        </div>

        {erro && <div className="field-error" role="alert">{erro}</div>}

        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
          <button type="submit" className="btn-primary" disabled={busy}>
            {busy && <Loader2 size={16} style={{ animation: 'spin 1s linear infinite' }} aria-hidden />}
            Criar médico e workspace
          </button>
          <Link to="/admin/medicos" className="btn-secondary">Cancelar</Link>
        </div>
        <style>{'@keyframes spin{to{transform:rotate(360deg)}}'}</style>
      </form>
    </div>
  )
}
